//Decodes HTML entities so &#8211 becomes "-" etc.
export function toPlainText(html) {
    let txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}


// WEBPACK FOOTER //
// ./src/utils/PlainText.js